import React, { useState, useEffect } from 'react';
import Gallery from 'react-photo-gallery';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  CardImg
} from 'reactstrap';

import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { gAPI_Call_Flows } from '../../../../../../constants/APIs';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../../propinfo/gallery/index';
let arr = [];
export default function SMS({
  integration,
  integrationProperties,
  allProperties,
  saveIntegration,
}) {
  const [smsSettings, setSMSSettings] = useState(integration?.phoneSuiteIntegration?.smsSettings || {
    smsNumber: '',
    bulkSMS: false,
    syncSMS: false,
    individualSMS: false
  });

  const handleSave = () => {
    saveIntegration({ smsSettings: smsSettings });
  };


  const handleSMSNumber = (e) => {
    setSMSSettings({ ...smsSettings, smsNumber: e.target.value });
  };

  const handleIndividualSMS = (e) => {
    setSMSSettings({ ...smsSettings, individualSMS: e });
  };
  const handleSynsSMS = (e) => {
    setSMSSettings({ ...smsSettings, syncSMS: e });
  };
  const handleBulkSMS = (e) => {
    setSMSSettings({ ...smsSettings, bulkSMS: e });
  };


  return (<Card className="mb-4">
    <CardBody>
      <div className="text-center mb-2">
        <h6>SMS</h6>
      </div>
      <Separator className="mb-3" />
      <div className="row mt-1 ml-2 mb-1">
        <div className="w-100">
          <h5 style={{ marginTop: '0.15rem' }}>SMS Number</h5>
          <p>Type Number With Country Code</p>
          <Input
            type="text"
            value={smsSettings.smsNumber}
            onChange={handleSMSNumber}
            className="mb-2"
            style={{ width: '50%' }}
            placeholder="SMS Number"
          >
          </Input>
        </div>
      </div>
      <Separator className="mb-3" />
      <div className="row mt-1 ml-2 mb-1">
        <div className="d-flex w-100">
          <h5 style={{ marginTop: '0.15rem' }}>Individual SMS sending</h5>
          <Switch
            className="agentswitch  custom-switch-primary custom-switch-small ml-2"
            checked={smsSettings?.individualSMS}
            name='recording'
            onChange={(e) => handleIndividualSMS(e)}
          />
        </div>
        <div className="row " style={{ marginLeft: '-0.5rem' }}>
          <p className="m-2">When enabled, you can send messages to customers one at a time</p>
        </div>
      </div>
      <Separator className="mb-3" />
      <div className="row mt-1 ml-2 mb-1">
        <div className="d-flex w-100">
          <h5 style={{ marginTop: '0.15rem' }}>Sync SMS response</h5>
          <Switch
            className="agentswitch  custom-switch-primary custom-switch-small ml-2"
            checked={smsSettings?.syncSMS}
            name='transcribe'
            onChange={(e) => handleSynsSMS(e)}
          />
        </div>
        <div className="row " style={{ marginLeft: '-0.5rem' }}>
          <p className="m-2">When enabled, the response to a message will be pulled into the dashoard</p>
        </div>
      </div>
      <Separator className="mb-3" />
      <div className="row mt-1 ml-2 mb-1">
        <div className="d-flex w-100">
          <h5 style={{ marginTop: '0.15rem' }}>Bulk SMS sending</h5>
          <Switch
            className="agentswitch  custom-switch-primary custom-switch-small ml-2"
            checked={smsSettings?.bulkSMS}
            name='transcribe'
            onChange={(e) => handleBulkSMS(e)}
          />
        </div>
        <div className="row " style={{ marginLeft: '-0.5rem' }}>
          <p className="m-2">Coming Soon</p>
        </div>
      </div>

      <div className="d-flex justify-content-center mt-1 ml-2 mb-1">
        <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
          <Button color="primary" size="xs" outline onClick={handleSave}>
            Save
          </Button>
        </ButtonGroup>
      </div>
    </CardBody>
  </Card>);
}
